(function ($) {
  Drupal.behaviors.productAfterpayInstallmentV1 = {
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      // Import external afterpay js
      self.importAfterpay();
      // Init the afterpay widget
      self.initAfterpay(context);
    },
    importAfterpay: function () {
      var imported = document.createElement('script');
      var afterpay = Drupal.settings.afterpay;

      imported['data-min'] = afterpay.product_price_threshold_min;
      imported['data-max'] = afterpay.product_price_threshold_max;
      imported.async = true;
      imported.src = 'https://js.afterpay.com/afterpay-1.x.js';
      document.head.appendChild(imported);
    },
    initAfterpay: function (context) {
      var afterpay = Drupal.settings.afterpay;
      var currency = Drupal.settings.globals_variables.currency_code || 'USD';
      var amount = $('.js-spp-content .js-product-price-v1', context)
        .html()
        .replace(/[^0-9]/gu, '');

      $('.js-product-price-divider', context).html(
        '<afterpay-placement data-locale="' +
          afterpay.locale +
          '" data-badge-theme="' +
          (afterpay.badge_theme || 'black-on-mint') +
          '" data-currency="' +
          currency +
          '" data-amount="' +
          parseInt(amount, 10) / 100 +
          '"></afterpay-placement>'
      );
    },
    attached: false
  };
})(jQuery);
